
export default {
  props: {
    otpValue: {
      type: String,
      default: ""
    },
    classProp: {
      type: String,
      default: "order-chip"
    }
  }
};
